<template>
  <div>
    <Toggle v-model="mutableValue" class="toggle-hype"> </Toggle>
  </div>
</template>

<script>
import Toggle from "@vueform/toggle";

export default {
  components: {
    Toggle,
  },
  props: {
    modelValue: { type: [Boolean, String] },
  },
  computed: {
    mutableValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
};
</script>

<style src="@vueform/toggle/themes/default.css"></style>

<style>
.toggle-hype {
  --toggle-bg-on: linear-gradient(
    90deg,
    #00daee 0%,
    #348cff 20%,
    #3981fc 40%,
    #4765f5 60%,
    #5f38ea 80%,
    #652de8 100%
  );
  --toggle-bg-off: linear-gradient(
    90deg,
    #20f281 0%,
    rgba(27, 122, 71, 0.86) 100%
  );
  --toggle-border-on: #fff;
  --toggle-ring-width: 0px;
}
</style>
